import { motion } from "framer-motion";

export function Reveal({ children, delay = 0, y = 40, className = "", ...rest }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
      {...rest}
    >
      {children}
    </motion.div>
  );
}

export function fmtPrice(v, currency = "usd") {
  return new Intl.NumberFormat("es-ES", { style: "currency", currency: currency.toUpperCase(), maximumFractionDigits: 0 }).format(v);
}

export const CATEGORY_LABELS = {
  physical: "Equipos",
  software: "Software",
  consulting: "Consultoría",
};
